import { tv } from 'tailwind-variants';

export const textAreaField = tv(
  {
    slots: {
      container: ['group', 'relative', 'isolate', 'flex', 'w-fit', 'min-w-[192px]', 'flex-col', 'gap-2'],
      input: [
        'min-h-[44px]',
        'max-h-[512px]',
        'appearance-none',
        'bg-base',
        'border',
        'border-gray',
        'hover:border-gray-dark-1',
        'rounded-md',
        'text-b-sm',
        'leading-b-sm',
        'text-strong',
        'placeholder:text-weak',
        'py-2.5',
        'px-3',
        'outline-none',
        'transition-colors',
        'enabled:data-[focus-visible=true]:outline',
        'enabled:data-[focus-visible=true]:outline-offset-[-1px]',
        'enabled:data-[focused=true]:border-accent',
        'enabled:data-[focused=true]:data-[hovered=false]:border-accent',
        'enabled:data-[focus-visible=true]:outline-accent',
        'enabled:aria-invalid:border-critical',
        'enabled:aria-invalid:data-[hovered=false]:border-critical',
        'enabled:aria-invalid:data-[hovered=true]:border-critical',
        'enabled:aria-invalid:data-[focused=true]:border-critical',
        'enabled:aria-invalid:data-[focus-visible=true]:outline-critical',
        'disabled:bg-neutral-weak',
        'disabled:border-neutral-weak',
      ],
    },
  },
  { twMerge: false },
);
